import actionTypes from '../constants/action-types';

const clearPageTemplatesHtml = () => ({
  type: actionTypes.CLEAR_PAGE_TEMPLATES_HTML,
});

export default clearPageTemplatesHtml;
